import { h } from "./../../utils/createElement";
import { __assign, __extends, __spreadArray } from "tslib";
import * as React from 'react';
export default function create(createOption) {
    return function (C) {
        return (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.state = {};
                _this.form = {
                    getFieldDecorator: function (id, option) {
                        if (option === void 0) { option = {}; }
                        return function (E) {
                            var _a;
                            var onChange = function (value) {
                                var _a;
                                var args = [];
                                for (var _i = 1; _i < arguments.length; _i++) {
                                    args[_i - 1] = arguments[_i];
                                }
                                if (typeof E.props.onChange === 'function') {
                                    (_a = E.props).onChange.apply(_a, __spreadArray([value], args));
                                }
                                _this.setState(function (state) {
                                    var _a;
                                    return (_a = {},
                                        _a[id] = __assign(__assign({}, state[id]), { touched: true, value: value }),
                                        _a);
                                }, function () {
                                    if (createOption && typeof createOption.onValuesChange === 'function') {
                                        createOption.onValuesChange(_this.form.getFieldsValue([id]), _this.form.getFieldsValue());
                                    }
                                });
                            };
                            if (_this.state[id] === undefined && option.initialValue !== undefined) {
                                _this.state[id] = __assign(__assign({}, _this.state[id]), { value: option.initialValue });
                            }
                            _this.state[id] = __assign(__assign({}, _this.state[id]), { option: option });
                            return React.cloneElement(E, {
                                'data-create-form-payload': {
                                    id: id,
                                    form: _this.form,
                                    option: option
                                },
                                onChange: onChange,
                                value: (_a = _this.state[id]) === null || _a === void 0 ? void 0 : _a.value
                            });
                        };
                    },
                    getFieldValue: function (id) {
                        var _a;
                        return (_a = _this.state[id]) === null || _a === void 0 ? void 0 : _a.value;
                    },
                    getFieldsValue: function (ids) {
                        if (Array.isArray(ids)) {
                            var values_1 = {};
                            ids.forEach(function (id) {
                                if (_this.state[id]) {
                                    values_1[id] = _this.state[id].value;
                                }
                            });
                            return values_1;
                        }
                        else {
                            var values_2 = {};
                            Object.keys(_this.state).forEach(function (id) {
                                if (_this.state[id]) {
                                    values_2[id] = _this.state[id].value;
                                }
                            });
                            return values_2;
                        }
                    },
                    setFieldsValue: function (values) {
                        Object.keys(values).forEach(function (id) {
                            if (_this.state[id]) {
                                _this.setState(function (state) {
                                    var _a;
                                    return (_a = {},
                                        _a[id] = __assign(__assign({}, state[id]), { value: values[id] }),
                                        _a);
                                });
                            }
                        });
                    },
                    resetFields: function (ids) {
                        if (Array.isArray(ids)) {
                            ids.forEach(function (id) {
                                if (_this.state[id]) {
                                    _this.setState(function (state) {
                                        var _a;
                                        return (_a = {},
                                            _a[id] = __assign(__assign({}, state[id]), { touched: false, value: state[id].option.initialValue }),
                                            _a);
                                    });
                                }
                            });
                        }
                        else {
                            Object.keys(_this.state).forEach(function (id) {
                                _this.setState(function (state) {
                                    var _a;
                                    return (_a = {},
                                        _a[id] = __assign(__assign({}, state[id]), { touched: false, value: state[id].option.initialValue }),
                                        _a);
                                });
                            });
                        }
                    },
                    isFieldTouched: function (id) {
                        var _a;
                        return Boolean((_a = _this.state[id]) === null || _a === void 0 ? void 0 : _a.touched);
                    },
                    validateFields: function (cb) {
                        _this.setState(function (state) {
                            var obj = {};
                            Object.keys(state).forEach(function (k) {
                                obj[k] = __assign(__assign({}, state[k]), { touched: true });
                            });
                            return obj;
                        });
                        cb(_this.form.getFieldsError(), _this.form.getFieldsValue());
                    },
                    getFieldError: function (id) {
                        return _this.validate(id);
                    },
                    getFieldsError: function (ids) {
                        var obj;
                        if (Array.isArray(ids)) {
                            ids.forEach(function (id) {
                                obj = __assign(__assign({}, obj), _this.validate(id));
                            });
                        }
                        else {
                            Object.keys(_this.state).forEach(function (id) {
                                obj = __assign(__assign({}, obj), _this.validate(id));
                            });
                        }
                        return obj;
                    }
                };
                _this.validate = function (id) {
                    var _a;
                    if (_this.state[id]) {
                        var option = _this.state[id].option;
                        var value_1 = _this.state[id].value;
                        if (Array.isArray(option.rules)) {
                            var errors = option.rules.filter(function (rule) {
                                if (rule.required === true) {
                                    if (value_1 === undefined || value_1 === '') {
                                        return true;
                                    }
                                }
                                if (rule.min !== undefined && !isNaN(rule.min)) {
                                    if (value_1 === undefined || value_1 === '') {
                                        if (rule.min > 0) {
                                            return true;
                                        }
                                    }
                                    else {
                                        if (typeof value_1 === 'string') {
                                            if (rule.min > value_1.length) {
                                                return true;
                                            }
                                        }
                                    }
                                }
                                if (rule.max !== undefined && !isNaN(rule.max)) {
                                    if (typeof value_1 === 'string') {
                                        if (rule.max < value_1.length) {
                                            return true;
                                        }
                                    }
                                }
                                if (typeof rule.validator === 'function') {
                                    return !rule.validator(value_1);
                                }
                                return false;
                            }).map(function (rule) {
                                return {
                                    field: id,
                                    message: rule.message
                                };
                            });
                            if (errors.length) {
                                return _a = {},
                                    _a[id] = {
                                        errors: errors
                                    },
                                    _a;
                            }
                        }
                    }
                    return;
                };
                return _this;
            }
            class_1.prototype.render = function () {
                return h(C, __assign({}, this.props, { form: this.form }));
            };
            return class_1;
        }(React.Component));
    };
}
